<div>
    <app-shared-dashboard-tasks
        [action]="data.action"
        [target]="data.target"
        [title]="data.title"
        [wording]="data.wording"
        [canCreateTasks]="data.canCreateTasks"
        (taskCreated)="taskCreated = true"
    ></app-shared-dashboard-tasks>
</div>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="taskCreated">Fermer</button>
</mat-dialog-actions>
